module.exports = __webpack_public_path__ + "img/file-upload-modal-2.eacb11fa.png";